export default __webpack_public_path__ + "static/media/June2016.a50b8882.png";